import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { UserDataService } from '../../../_services/data-services/user-data.service';
import { Router , RouterModule } from '@angular/router';
import { SnoozeModalService } from '../../../_services/snooze-modal.service';
import { PhoneFormatter } from '../../../_helpers/_formatters/phone-formatter';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-validate-customer-modal',
  templateUrl: './validate-customer-modal.component.html',
  styleUrls: ['./validate-customer-modal.component.scss'],
})
export class ValidateCustomerModalComponent implements OnInit {
  @Input() title: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  validateCustomerModalOptions: ModalOptions;
  hideModal = false;
  email: string;
  phone: any = {};
  isAcmic = false;
  confirmInfo: string;
  loading: boolean;

  constructor(
    private userDataService: UserDataService,
    private snoozeModalService: SnoozeModalService,
    private router: Router,
    private phoneFormater: PhoneFormatter,
    private acmicService: AcmicService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
  }

  triggerModal() {
    this.validateCustomerModalOptions = new ModalOptions({
      additionalClasses: `autopay-modal modal-medium modal-dialog modal-center-on-page upload-document-modal`,
      additionalButtonClasses: 'ghost tertiary small',
      onLoad: true,
      buttonCopy: '',
      modalId: 'validate_customer',
      modalName: 'validateCustomer',
    });
  }
  callHide(): void {
    this.hideModal = !this.hideModal;
    this.closeModal.emit(true);
  }
  resetHideModal(): void {
    this.callHide();
    localStorage.setItem(
      'cpModalsnoozeSince',
      JSON.stringify({ daysSinceLastLogin: 0, daysSinceLastSnooze: 0 })
    );
    this.snoozeModalService.snoozeCPModal(this.email).subscribe(() => {
      // tbd
    });
  }

  hideOnClick(event) {
    if (!event.target.closest('.modal-body')) {
      this.resetHideModal();
    }
  }

  cancelModal(event) {
    if (event) {
      this.resetHideModal();
    }
  }
  gotoManageContact() {
    this.resetHideModal();
    this.router.navigate(['profile', 'manage-contact-details']);
  }
  getPrimaryPhone(phoneList) {
    this.phone = phoneList && phoneList.find((phone) => phone.primary && this.isValidPhoneNumber(phone.number));
    if(!this.phone){
      this.phone = phoneList && phoneList.find((phone) => phone.type === 'cell' && this.isValidPhoneNumber(phone.number));
    }

    if(!this.phone){
      this.phone = phoneList && phoneList.find((phone) => phone.type === 'home' && this.isValidPhoneNumber(phone.number));
    }

    if(!this.phone){
      this.phone = phoneList && phoneList.find((phone) => phone.type === 'work' && this.isValidPhoneNumber(phone.number));
    }

    if (this.phone && this.phone.number) {
      this.phone.number = this.phoneFormater.format(this.phone.number);
    }
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.email = user.userDetails.email && user.userDetails.email.address;
        this.getPrimaryPhone(user.userDetails.phoneList);
        this.loading = false;
      }
    });
  }
  ngOnInit(): void {
    this.confirmInfo = (this.title.includes("updates to your account recently")) 
                        ? "CONFIRM_CONTACT_DETAILS" 
                        : "PLEASE_REVIEW_AND_UPDATE_YOUR";
    this.getUserData();
    this.triggerModal();
  }

  private isValidPhoneNumber(number: string): boolean{
    return number && number.trim().length > 0;    
  }
}
